import { render, staticRenderFns } from "./m_indonesian_leadership_classD.vue?vue&type=template&id=9f306c12&scoped=true"
import script from "./m_indonesian_leadership_classD.vue?vue&type=script&lang=js"
export * from "./m_indonesian_leadership_classD.vue?vue&type=script&lang=js"
import style0 from "./m_indonesian_leadership_classD.vue?vue&type=style&index=0&id=9f306c12&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f306c12",
  null
  
)

export default component.exports